import { render } from "./draggableView.vue?vue&type=template&id=40249f78"
import script from "./draggableView.vue?vue&type=script&lang=js"
export * from "./draggableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__